const AuthProcessFinally = (props) => {
	return (
		<div>
			<h1>Login Finalizado com sucesso. Feche esta aba verifique no portal</h1>
		</div>
	);
};

export default AuthProcessFinally;
